import React, { useEffect, useMemo, useState } from "react";
import {
	Card,
	Row,
	Col,
	Form,
	Select,
	Button,
	Tag,
	Space,
	Typography,
	message,
	Modal,
	List,
	Radio,
	Menu,
	Dropdown,
	Spin,
	Tabs,
} from "antd";
import {
	SafetyCertificateOutlined,
	LeftOutlined,
	RightOutlined,
	CloseCircleOutlined,
	RightCircleOutlined,
	InfoCircleOutlined,
	PlusOutlined,
	UserOutlined,
	LoadingOutlined,
	InfoCircleFilled,
	DownloadOutlined,
} from "@ant-design/icons";
import {
	ActionButton,
	AntdButton,
	AntdInput,
	AntdTable,
	ButtonContainer,
	CompaginationDiv,
	ConfirmButton,
	FiltersCard,
	ModalContainer,
	Page,
	Section,
	TitleContainer,
	UploadFile,
} from "./styles";
import { useParams } from "react-router-dom";
import {
	add_agent_route_by_cuit,
	add_agent_routes,
	agent_routes_to_validate,
	confirm_validation,
	export_agent_routes_to_validate,
	find_pos_candidates,
	get_agent_route_page,
	update_agent_route_state,
	update_agent_route_tag,
	validate_whatsapp_single,
	validate_whatsapps_list,
} from "../../../../../api/endpoints/agents";
import { CONSTANTS } from "../../../../../utils/constants";
import {
	openNotificationWithIcon,
	TYPE,
} from "../../../../../utils/notificationToast";
import { COLORS, Typo } from "../../../../layout/theme";
import { BsThreeDotsVertical, BsUpload } from "react-icons/bs";
import { get_general_pos_page } from "../../../../../api/endpoints/pointsofsale";
import DropShadow from "../../../../common/drop-shadow/DropShadow";
import SignInTemplate from "../../../../layout/sign-in-template/SignInTemplate";
import AntdSearch from "../../../../common/antd-search/AntdSearch";
import debounce from "lodash/debounce";
import PrePosTable from "./components/pre-pos-table/PrePosTable";
import CreatePosModal from "./components/create-pos-modal/CreatePosModal";
import PosUsersModal from "./components/pos-user-modal/PosUserModal";
import { useAuth } from "../../../../../contexts/authContext";
import Image from "../../../../common/image/Image";
import moment from "moment";
import { getWhatsappTagConfig } from "../../../../../utils/whatsappHelpers";
import AntdSelect from "../../../../common/antd-select/AntdSelect";

let productIndex = null;

export default function LaboratoryAgentRoutesPage({ isSystemAdmin }) {
	const { id: clientId } = useParams();
	const { userdata } = useAuth();
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [headerInfo, setHeaderInfo] = useState(null);
	const [clientGeneralPos, setClientGeneralPos] = useState([]);

	const [poolFilter, setPoolFilter] = useState("ALL");
	const [stateFilter, setStateFilter] = useState("ACTIVE");

	const [searchInfo, setSearchInfo] = useState(null);
	const [paginationInputValue, setPaginationInputValue] = useState(null);
	const [pageSize, setPageSize] = useState(CONSTANTS.PAGE_LARGE_SIZE);
	const [actualPage, setActualPage] = useState(1);
	const [searchTerm, setSearchTerm] = useState("");

	const [key, setKey] = useState("null");
	const [errors, setErrors] = useState(null);
	const [importResponse, setImportResponse] = useState(null);
	const [showUploadFileModal, setShowUploadFileModal] = useState(false);

	const [validateOpen, setValidateOpen] = useState(false);
	const [validateLoading, setValidateLoading] = useState(false);
	const [validateCandidates, setValidateCandidates] = useState([]);
	const [validateSelected, setValidateSelected] = useState(null);
	const [validateRow, setValidateRow] = useState(null);

	const [hasChanges, setHasChanges] = useState(false);
	const [data, setData] = useState(null);
	const [modalPage, setModalPage] = useState(1);
	const [modalTotalPages, setModalTotalPages] = useState(1);
	const [modalTotalRecords, setModalTotalRecords] = useState(0);

	const [searchPrePos, setSearchPrePos] = useState(null);
	const [searchModalShow, setSearchModalShow] = useState(false);
	const [toogleAdd, setToogleAdd] = useState(false);
	const [provinceName, setProvinceName] = useState(null);
	const [localityName, setLocalityName] = useState(null);
	// const [listadoProvincias, setListadoProvincias] = useState([]);
	const [createOpen, setCreateOpen] = useState(false);
	const [posUsersOpen, setPosUsersOpen] = useState(false);
	const [posForUsers, setPosForUsers] = useState(null);

	const [toogleValidation, setToogleValidation] = useState(false);
	const [flag, setFlag] = useState(false);
	const [uploadType, setUploadType] = useState(CONSTANTS.ROUTE_ASSING);
	const [validateBulkResult, setValidateBulkResult] = useState(null);
	const [validateBulkModalOpen, setValidateBulkModalOpen] = useState(false);
	const [forceOverwriteLockedWhatsapp, setForceOverwriteLockedWhatsapp] =
		useState(false);
	const [editingTags, setEditingTags] = useState({});
	const [savingTagId, setSavingTagId] = useState(null);

	const fetchAgentRoutePage = async ({ search, page }) => {
		try {
			setLoading(true);
			const res = await get_agent_route_page(
				search,
				clientId,
				poolFilter,
				stateFilter,
				page,
				pageSize,
			);
			setClientGeneralPos(
				res.items.map((r) => ({
					...r,
					key: r.id,
					name: r.pdvName,
					pointOfSaleId: r.pointOfSaleId,
					routeTag: r.routeTag || "",
					hasChanges: false,
				})),
			);

			setSearchInfo(res?.paginationInfo);
			setPaginationInputValue(res?.paginationInfo?.actualPage?.toString());
		} catch (e) {
			console.error(e);
			message.error("No se pudo obtener el listado.");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		setActualPage(1);
		setPaginationInputValue("1");
		fetchAgentRoutePage({ search: searchTerm, page: 1 });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [clientId, poolFilter, stateFilter, pageSize, flag, searchTerm]);

	const prePosColumns = [
		{
			title: () => <div style={{ color: COLORS.White }}>Nombre</div>,
			dataIndex: "name",
			key: "name",
			render: (t, item) => (
				<Typo
					type="primary"
					lineHeight={1}
					texto="medium"
					fontSize={t.length < 15 ? 18 : 16}
				>
					{t}
				</Typo>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Agregar</div>,
			width: 100,
			key: "action",
			render: (_, record, index) => (
				<Space size="middle">
					<Button
						type="primary"
						ghost
						onClick={() => {
							handleAddToTemplate(index);
						}}
					>
						<RightCircleOutlined />
					</Button>
				</Space>
			),
		},
	];

	const columns = [
		{
			title: () => <div style={{ color: COLORS.White }}>Nombre</div>,
			dataIndex: "name",
			render: (value, record) => (
				<Typo
					type={record.hasChanges ? "muted" : "secondary"}
					fontWeight={600}
					fontSize={14}
					onMouseOver={() => setKey(record)}
				>
					{value}
				</Typo>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Cuit</div>,
			dataIndex: "cuit",
			render: (value, record) => (
				<Typo
					type={record.hasChanges ? "muted" : "secondary"}
					fontWeight={600}
					fontSize={14}
				>
					{value}
				</Typo>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Dirección</div>,
			dataIndex: "address",
			render: (value, record) => (
				<Typo
					type={record.hasChanges ? "muted" : "secondary"}
					fontWeight={600}
					fontSize={14}
				>
					{value}
				</Typo>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Provincia</div>,
			dataIndex: "province",
			render: (value, record) => (
				<Typo
					type={record.hasChanges ? "muted" : "secondary"}
					fontWeight={600}
					fontSize={14}
				>
					{value}
				</Typo>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Localidad</div>,
			dataIndex: "location",
			render: (value, record) => (
				<Typo
					type={record.hasChanges ? "muted" : "secondary"}
					fontWeight={600}
					fontSize={14}
				>
					{value}
				</Typo>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Tag interno</div>,
			dataIndex: "routeTag",
			key: "routeTag",
			width: 220,
			render: (value, record) => (
				<AntdInput
					value={
						editingTags[record.id] !== undefined
							? editingTags[record.id]
							: value || ""
					}
					onChange={(e) => handleRouteTagChange(record.id, e.target.value)}
					onBlur={() => handleSaveRouteTag(record)}
					onPressEnter={() => handleSaveRouteTag(record)}
					placeholder="Ingresar tag"
					disabled={savingTagId === record.id}
				/>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Validacion</div>,
			dataIndex: "isValidated",
			key: "isValidated",
			width: 160,
			render: (v, r) =>
				v ? (
					<Space>
						{(() => {
							const { text, color } = getWhatsappTagConfig(
								r.hasWhatsappUser,
								r.hasWhatsappValidated,
								r.hasWhatsappLocked,
							);

							return <Tag color={color}>{text}</Tag>;
						})()}
						<Button
							size="small"
							onClick={() => {
								if (!r.pointOfSaleId)
									return message.info("El registro no tiene PointOfSaleId.");
								setPosForUsers(r.pointOfSaleId);
								setPosUsersOpen(true);
							}}
							icon={<UserOutlined />}
							style={{ borderRadius: 20 }}
						/>
					</Space>
				) : userdata.isOneMarket || isSystemAdmin ? (
					<Button
						size="small"
						icon={<SafetyCertificateOutlined />}
						onClick={() => openValidateModal(r)}
					>
						Validar
					</Button>
				) : (
					<Tag>Falta validar</Tag>
				),
		},
		productIndex || importResponse
			? {
					title: "",
					key: "action",
					width: 30,
					render: (_, record, index) => (
						<Space size="middle">
							{record.hasChanges && (
								<CloseCircleOutlined onClick={() => handleDelete(index)} />
							)}
						</Space>
					),
				}
			: {
					title: "",
					key: "id",
					dataIndex: "id",
					width: 30,
					render: (f, r, i) => (
						<>
							<Dropdown
								overlay={stateFilter === "ACTIVE" ? menuActive : menuDeleted}
								placement="bottomRight"
							>
								<ActionButton key={`${f}`} onMouseOver={() => setKey(r)}>
									<BsThreeDotsVertical />
								</ActionButton>
							</Dropdown>
						</>
					),
				},
	];

	const menuActive = (
		<Menu
			items={[
				{
					key: "2",
					label: <Typo onClick={() => deleteRoute(key?.id)}>Eliminar</Typo>,
				},
			]}
		/>
	);

	const menuDeleted = (
		<Menu
			items={[
				{
					key: "2",
					label: <Typo onClick={() => activateRoute(key?.id)}>Activar</Typo>,
				},
			]}
		/>
	);

	const deleteRoute = (key) => {
		Modal.confirm({
			title: "¿Seguro que quiere eliminar esta ruta?",
			icon: <CloseCircleOutlined style={{ color: "red" }} />,
			content: "La ruta se quitará de inmediato",
			okText: "Sí",
			okType: "default",
			cancelText: "No",
			onOk: () => {
				handleAction(key, "DELETED");
			},
		});
	};

	const activateRoute = (key) => {
		Modal.confirm({
			title: "¿Seguro que quiere activar esta ruta?",
			icon: <CloseCircleOutlined style={{ color: "red" }} />,
			content: "La ruta se activara de inmediato",
			okText: "Sí",
			okType: "default",
			cancelText: "No",
			onOk: () => {
				handleAction(key, "ACTIVE");
			},
		});
	};

	const handleAction = async (key, state) => {
		try {
			const _state = { id: key, state: state };
			await update_agent_route_state(_state);
			fetchAgentRoutePage("", 1);
			// fetch_routes_header();
		} catch (err) {
			openNotificationWithIcon(
				TYPE.ERROR,
				"La ruta no se puede borrar",
				"La ruta no se puede borrar",
			);
		}
	};

	// Modal de Validación
	const openValidateModal = async (row) => {
		try {
			setValidateRow(row);
			setValidateOpen(true);
			setValidateLoading(true);
			setValidateCandidates([]);
			setValidateSelected(null);
			const candidates = await find_pos_candidates(row.id);
			setValidateCandidates(candidates?.pdvCandidates || []);
			if (candidates?.pdvCandidates?.length === 1) {
				setValidateSelected(candidates.pdvCandidates[0].pointOfSaleId);
			}
		} catch (e) {
			console.error(e);
			message.error("No se pudieron cargar candidatos por CUIT.");
		} finally {
			setValidateLoading(false);
		}
	};

	const handleConfirmValidation = async () => {
		if (!validateRow || !validateSelected) {
			return message.info("Elegí un punto de venta.");
		}
		try {
			setValidateLoading(true);
			await confirm_validation({
				agentRouteId: validateRow.id,
				pointOfSaleId: validateSelected,
			});
			message.success("PDV validado correctamente.");
			setValidateOpen(false);
			setValidateRow(null);
			setValidateCandidates([]);
			setValidateSelected(null);
			fetchAgentRoutePage("", 1);
		} catch (e) {
			console.error(e);
			message.error("No se pudo validar el PDV.");
		} finally {
			setValidateLoading(false);
		}
	};

	const goToPage = (page) => {
		if (!searchInfo) return;
		const p = Math.max(1, Math.min(page, searchInfo.totalPages));
		setActualPage(p);
		setPaginationInputValue(p.toString());
		fetchAgentRoutePage({ search: searchTerm, page: p });
	};

	const handleDecrement = () => goToPage(actualPage - 1);
	const handleIncrement = () => goToPage(actualPage + 1);

	const handlePageChange = (e) => {
		const selectedPage = parseInt(e.target.value, 10);
		if (!searchInfo) return;

		if (
			!isNaN(selectedPage) &&
			selectedPage >= 1 &&
			selectedPage <= searchInfo.totalPages
		) {
			goToPage(selectedPage);
		} else {
			setPaginationInputValue(actualPage.toString());
		}
	};

	const handleSubmit = () => {
		Modal.confirm({
			title: "¿Seguro que quiere publicar estas rutas?",
			icon: <InfoCircleOutlined style={{ color: "blue" }} />,
			content: "Los cambios se aplicaran de inmediato",
			okText: "Sí",
			okType: "default",
			cancelText: "No",
			onOk: () => {
				confirmChanges();
			},
		});
	};

	const confirmChanges = async () => {
		setLoading(true);
		try {
			const routesList = clientGeneralPos?.map((r) => ({
				id: r.id,
				clientId: clientId,
				preDefinedPointsOfSaleId: r.preDefinedPointsOfSaleId,
			}));

			const res = await add_agent_routes({
				routes: routesList,
				clientId: clientId,
			});
			openNotificationWithIcon(
				TYPE.SUCCESS,
				res,
				"Las rutas se actualizaron correctamente",
			);
			fetchAgentRoutePage("", 1);
			// fetch_routes_header();
			productIndex = null;
			setImportResponse(null);
		} catch (err) {
			console.log(err);
			openNotificationWithIcon(
				TYPE.ERROR,
				"Las rutas no se pudieron actualizar correctamente, contacte con soporte a soporte@checkpos.com",
				"Las rutas se se pudieron actualizar correctamente, contacte con soporte a soporte@checkpos.com",
			);
		} finally {
			setLoading(false);
		}
	};

	const handleUpload = async (e) => {
		setLoading(true);
		try {
			const formData = new FormData();
			formData.append(
				"data",
				JSON.stringify({ clientId: clientId ?? userdata.clientId }),
			);
			formData.append("file", e.fileList[e.fileList.length - 1].originFileObj);
			const res = await add_agent_route_by_cuit(formData);
			setImportResponse(res);
			handleAddToList(res.newPos);
			setErrors(res?.errors);
			if (res?.errors?.length > 0) {
				openNotificationWithIcon(
					TYPE.ERROR,
					"Los puntos de venta que intenta subir no se cargaron",
					"Los puntos de venta que intenta subir tienen problemas, reviselos y subalos de nuevo",
				);
			}
		} catch (err) {
			openNotificationWithIcon(
				TYPE.ERROR,
				"Las rutas no pudieron actualizarse",
				"Verifique su archivo de excel, si sigue con problemas contacte con soporte a soporte@checkpos.com",
			);
		} finally {
			setLoading(false);
			setShowUploadFileModal(false);
		}
	};

	const handleAddToList = (posList) => {
		const auxTemplate = clientGeneralPos.concat(posList);

		let uniqueArray = auxTemplate.filter((value, index) => {
			const _value = JSON.stringify(value);
			return (
				index ===
				auxTemplate.findIndex((obj) => {
					return JSON.stringify(obj) === _value;
				})
			);
		});

		uniqueArray = uniqueArray.filter(
			(value, index, self) =>
				index ===
				self.findIndex(
					(t) => t.preDefinedPointsOfSaleId === value.preDefinedPointsOfSaleId,
				),
		);

		setClientGeneralPos(uniqueArray);
	};

	const fetch_predefined_pos = async (search, page) => {
		setLoading(true);
		try {
			const res = await get_general_pos_page(
				search,
				provinceName,
				localityName,
				"ACTIVE",
				page || 1,
			);
			setData(
				res.pointsOfSale.map((r) => ({
					...r,
					quantity: 1,
					key: r.id,
					hasChanges: true,
					preDefinedPointsOfSaleId: r.id,
				})),
			);
			setModalPage(res.actualPage || 1);
			setModalTotalPages(res.totalPages || 1);
			setModalTotalRecords(res.totalRecords || 0);
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
			setSearchModalShow(true);
		}
	};

	//////******************************************************** */

	const handleAddToTemplate = async (e, q) => {
		const _template = data?.filter((p, idx) => idx === e);
		productIndex = _template;
		const auxTemplate = clientGeneralPos.concat(_template);

		let uniqueArray = auxTemplate.filter((value, index) => {
			const _value = JSON.stringify(value);
			return (
				index ===
				auxTemplate.findIndex((obj) => {
					return JSON.stringify(obj) === _value;
				})
			);
		});

		uniqueArray = uniqueArray.filter(
			(value, index, self) =>
				index ===
				self.findIndex(
					(t) => t.preDefinedPointsOfSaleId === value.preDefinedPointsOfSaleId,
				),
		);

		setClientGeneralPos(uniqueArray);
	};

	//////******************************************************** */

	const handleDelete = (index) => {
		const _template = clientGeneralPos.filter((p, idx) => idx !== index);
		setClientGeneralPos(_template);
	};

	//////******************************************************** */

	const eventHandlerAdd = (e) => {
		setSearchPrePos(e.target.value);
		fetch_predefined_pos(e.target.value, 1);
	};

	const debouncedEventHandlerAdd = useMemo(
		() => debounce(eventHandlerAdd, 600),
		[],
	);

	const handleModalOk = () => {
		setSearchPrePos(null);
		setSearchModalShow(false);
	};

	const handleModalCancel = () => {
		setSearchPrePos(null);
		setSearchModalShow(false);
	};

	const handleCancel = () => {
		productIndex = null;
		setImportResponse(null);
		fetchAgentRoutePage("", 1);
		// fetch_routes_header();
	};

	useEffect(() => {
		return () => {
			debouncedEventHandler.cancel();
		};
	}, []);

	const eventHandler = (e) => {
		setSearchTerm(e.target.value || "");
	};

	const debouncedEventHandler = useMemo(() => debounce(eventHandler, 600), []);

	const handleCreateStep = () => {
		setCreateOpen(true);
	};

	const handleUploadModalOk = () => {
		setShowUploadFileModal(false);
		setForceOverwriteLockedWhatsapp(false);
	};

	const handleUploadModalCancel = () => {
		setShowUploadFileModal(false);
		setForceOverwriteLockedWhatsapp(false);
	};

	const handleExportAgentRoute = async () => {
		setLoading(true);
		try {
			const res = await export_agent_routes_to_validate(clientId);
			const href = URL.createObjectURL(res);

			const link = document.createElement("a");
			link.href = href;

			const fileName =
				"Agent_Route" + "_" + moment().format("DDMMYYYY") + ".xlsx";
			link.setAttribute("download", fileName);
			document.body.appendChild(link);
			link.click();

			document.body.removeChild(link);
			URL.revokeObjectURL(href);
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	const handleUploadToValidate = async (e) => {
		setLoading(true);
		try {
			const formData = new FormData();
			formData.append(
				"data",
				JSON.stringify({
					clientId: clientId,
					forceOverwriteLockedWhatsapp: !!forceOverwriteLockedWhatsapp,
				}),
			);
			formData.append("file", e.fileList[e.fileList.length - 1].originFileObj);
			const res = await agent_routes_to_validate(formData);

			setValidateBulkResult(res);
			setValidateBulkModalOpen(true);

			if ((res?.errors ?? 0) > 0 || (res?.duplicates ?? 0) > 0) {
				openNotificationWithIcon(
					TYPE.WARNING,
					"Validación finalizada con observaciones",
					`Procesadas: ${res?.processed ?? 0} • Validadas: ${
						res?.validated ?? 0
					} • Duplicados: ${res?.duplicates ?? 0} • Errores: ${
						res?.errors ?? 0
					}`,
				);
			} else {
				openNotificationWithIcon(
					TYPE.SUCCESS,
					"Validación finalizada",
					`Procesadas: ${res?.processed ?? 0} • Validadas: ${
						res?.validated ?? 0
					}`,
				);
			}
		} catch (err) {
			console.log(err);
			openNotificationWithIcon(
				TYPE.ERROR,
				"Las rutas no pudieron actualizarse",
				"Verifique su archivo de excel, si sigue con problemas contacte con soporte a soporte@checkpos.com",
			);
		} finally {
			setLoading(false);
			setFlag((prev) => !prev);
		}
	};

	const downloadText = (filename, text) => {
		const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
		const url = URL.createObjectURL(blob);
		const a = document.createElement("a");
		a.href = url;
		a.download = filename;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
		URL.revokeObjectURL(url);
	};

	const handleValidateWhatsappList = async () => {
		try {
			setLoading(true);
			await validate_whatsapps_list(clientId);
			message.success("Validación de WhatsApps ejecutada correctamente.");
			await fetchAgentRoutePage({ search: searchTerm, page: actualPage });
		} catch (e) {
			console.error(e);
			message.error("No se pudo validar la lista de WhatsApps.");
		} finally {
			setLoading(false);
		}
	};

	const handleValidateWhatsappSingle = async (record) => {
		const userId = record?.id;
		const waId = (record?.whatsappUserId || "").trim();

		if (!userId) return message.info("No hay userId en el registro.");
		if (!waId)
			return message.info("El registro no tiene whatsappUserId para validar.");

		try {
			setLoading(true);
			const res = await validate_whatsapp_single(userId, waId, clientId);
			if (res?.ok) {
				message.success(res.message);
			} else {
				message.warning(res.message);
			}
			await fetchAgentRoutePage({ search: searchTerm, page: actualPage });
		} catch (e) {
			console.error(e);
			message.error("No se pudo validar el WhatsApp.");
		} finally {
			setLoading(false);
		}
	};

	const handleRouteTagChange = (id, value) => {
		setEditingTags((prev) => ({
			...prev,
			[id]: value,
		}));
	};

	const handleSaveRouteTag = async (record) => {
		const newTag =
			editingTags[record.id] !== undefined
				? editingTags[record.id]
				: record.routeTag || "";

		if ((newTag || "") === (record.routeTag || "")) return;

		try {
			setSavingTagId(record.id);

			await update_agent_route_tag({
				id: record.id,
				routeTag: newTag?.trim() || null,
			});

			message.success("Tag interno actualizado correctamente.");

			await fetchAgentRoutePage({
				search: searchTerm,
				page: actualPage,
			});

			setEditingTags((prev) => {
				const copy = { ...prev };
				delete copy[record.id];
				return copy;
			});
		} catch (e) {
			console.error(e);
			message.error("No se pudo guardar el tag interno.");
		} finally {
			setSavingTagId(null);
		}
	};

	return (
		<Page>
			<FiltersCard title="Ruta Agente">
				<Form form={form} layout="vertical">
					<Row gutter={10} style={{ display: "flex", alignItems: "center" }}>
						<Col span={5}>
							<AntdSearch
								allowClear
								placeholder="Buscar asignados"
								onChange={debouncedEventHandler}
								style={{ borderRadius: 15, height: 35, marginTop: 4 }}
							/>
						</Col>
						<Col span={5}>
							<Form.Item
								label={
									<ButtonContainer>
										Estado validacion{" "}
										{searchInfo && searchInfo?.totalRecords > 0 && (
											<Typo type="grey" level={6}>
												({searchInfo?.totalRecords} registros)
											</Typo>
										)}
									</ButtonContainer>
								}
							>
								<AntdSelect
									value={poolFilter}
									onChange={(v) => setPoolFilter(v)}
									options={[
										{ label: "Todos", value: "ALL" },
										{ label: "Ruta Validada", value: "VALIDATED" },
										{ label: "Ruta sin validar", value: "UNVALIDATED" },
										{ label: "Ruta con WhatsApp", value: "HAS_WA" },
										{ label: "Ruta sin WhatsApp", value: "NO_HAS_WA" },
										{ label: "WhatsApp validado OK", value: "WA_VALIDATED" },
										{ label: "WhatsApp sin validar", value: "WA_PENDING" },
										{ label: "WhatsApp locked", value: "WA_LOCKED" },
									]}
								/>
							</Form.Item>
						</Col>
						<Col span={5}>
							<Form.Item label="Estado de registro">
								<AntdSelect
									value={stateFilter}
									onChange={(v) => {
										setStateFilter(v);
									}}
									options={[
										{ label: "Activos", value: "ACTIVE" },
										{ label: "Eliminados", value: "DELETED" },
										{ label: "Todos", value: "ALL" },
									]}
								/>
							</Form.Item>
						</Col>
						<Col span={9}>
							{(userdata.isOneMarket || isSystemAdmin) && (
								<div>
									{!toogleAdd && (
										<DropShadow type="drop">
											<SignInTemplate.AntdButton
												type="primary"
												bg="Primary"
												color="White"
												onClick={async () => {
													setToogleAdd((prev) => !prev);
													await fetch_predefined_pos("", 1);
												}}
												icon={<PlusOutlined />}
												style={{ width: "200px", fontWeight: "400" }}
												disabled={!!importResponse || !!productIndex}
											>
												Agregar PDV
											</SignInTemplate.AntdButton>
										</DropShadow>
									)}
									{toogleAdd && (
										<div style={{ display: "flex", gap: 10 }}>
											<AntdSearch
												allowClear
												placeholder="Buscar punto de venta general"
												width={300}
												onChange={(e) => setSearchPrePos(e.target.value)}
												value={searchPrePos}
												onPressEnter={(e) => debouncedEventHandlerAdd(e)}
												disabled={loading}
											/>
											<AntdButton
												loading={loading}
												style={{
													display: "flex",
													justifyContent: "center",
													alignItems: "center",
													width: "230px",
												}}
												onClick={() => {
													setShowUploadFileModal(true);
													setUploadType(CONSTANTS.ROUTE_ASSING);
												}}
											>
												<BsUpload
													style={{
														position: "relative",
														top: "0.8px",
														left: "-5px",
													}}
												/>
												<Typo type="white" level={6}>
													Importar PDVs por Cuit
												</Typo>
											</AntdButton>
											<CloseCircleOutlined
												size="small"
												style={{ color: COLORS.Danger }}
												onClick={() => setToogleAdd((prev) => !prev)}
											/>
										</div>
									)}
								</div>
							)}
						</Col>
					</Row>
					{(userdata.isOneMarket || isSystemAdmin) && (
						<Row gutter={10}>
							<Col span={9}>
								{(userdata.isOneMarket || isSystemAdmin) && (
									<div>
										{!toogleValidation && (
											<DropShadow type="drop">
												<SignInTemplate.AntdButton
													type="Secondary"
													bg="Secondary"
													color="White"
													onClick={async () => {
														setToogleValidation((prev) => !prev);
													}}
													icon={<DownloadOutlined />}
													style={{ width: "200px", fontWeight: "400" }}
													disabled={!!importResponse}
												>
													Validacion masiva
												</SignInTemplate.AntdButton>
											</DropShadow>
										)}
										{toogleValidation && (
											<div style={{ display: "flex", gap: 10 }}>
												<AntdButton
													loading={loading}
													style={{
														display: "flex",
														justifyContent: "center",
														alignItems: "center",
														width: "230px",
													}}
													color={COLORS.Secondary}
													onClick={handleExportAgentRoute}
												>
													<Typo level={6}>Exportar ruta a validar</Typo>
												</AntdButton>
												<AntdButton
													loading={loading}
													style={{
														display: "flex",
														justifyContent: "center",
														alignItems: "center",
														width: "230px",
													}}
													onClick={() => {
														setShowUploadFileModal(true);
														setUploadType(CONSTANTS.ROUTE_VALIDATION);
													}}
												>
													<BsUpload
														style={{
															position: "relative",
															top: "0.8px",
															left: "-5px",
														}}
													/>
													<Typo type="white" level={6}>
														Validar por archivo
													</Typo>
												</AntdButton>
												<CloseCircleOutlined
													size="small"
													style={{ color: COLORS.Danger }}
													onClick={() => setToogleValidation((prev) => !prev)}
												/>
											</div>
										)}
									</div>
								)}
							</Col>
							<Col span={1}></Col>
							<Col span={9}>
								{(userdata.isOneMarket || isSystemAdmin) && (
									<AntdButton
										loading={loading}
										icon={<SafetyCertificateOutlined />}
										onClick={handleValidateWhatsappList}
										style={{
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
											width: "230px",
										}}
									>
										Validar WhatsApps (cliente)
									</AntdButton>
								)}
							</Col>
						</Row>
					)}
					{(userdata.isOneMarket || isSystemAdmin) && (
						<Row gutter={10}>
							<Col span={12}>
								{(hasChanges || productIndex || importResponse) && (
									<ConfirmButton clientId={clientId}>
										<AntdButton onClick={handleSubmit}>
											Confirmar cambios
										</AntdButton>{" "}
										<AntdButton onClick={handleCancel} color={COLORS.Danger}>
											Cancelar cambios
										</AntdButton>
									</ConfirmButton>
								)}
							</Col>
						</Row>
					)}
				</Form>
			</FiltersCard>

			<Card>
				<AntdTable
					loading={loading}
					dataSource={clientGeneralPos}
					columns={columns}
					// rowKey={(r) => r.AgentRouteId}
					rowKey={(r) => r.id}
					// rowSelection={rowSelection}
					pagination={false}
					// scroll={{ y: 500 }}
				/>
				{searchInfo && searchInfo?.totalRecords > 0 && (
					<CompaginationDiv>
						{searchInfo.actualPage !== 1 && (
							<Button size="small" shape="circle" onClick={handleDecrement}>
								<LeftOutlined />
							</Button>
						)}
						<AntdInput
							step={1}
							min={1}
							max={searchInfo.totalPages}
							onPressEnter={handlePageChange}
							onChange={(e) =>
								setPaginationInputValue(e.target.value?.toString() || "")
							}
							value={paginationInputValue}
							addonAfter={`/ ${searchInfo.totalPages}`}
							style={{
								width: ` ${searchInfo.totalPages > 99 ? "76px" : "66px"}`,
							}}
						/>
						{searchInfo.actualPage < searchInfo.totalPages && (
							<Button
								size="small"
								shape="circle"
								onClick={handleIncrement}
								disabled={
									searchInfo.actualPage === searchInfo.totalPages ? true : false
								}
							>
								<RightOutlined />
							</Button>
						)}
					</CompaginationDiv>
				)}
			</Card>

			{/* Modal Validar PDV */}
			<Modal
				open={validateOpen}
				title="Validar PDV por CUIT"
				okText={validateCandidates.length === 0 ? "Crear" : "Confirmar"}
				cancelText="Cancelar"
				confirmLoading={validateLoading}
				onOk={
					validateCandidates.length === 0
						? handleCreateStep
						: handleConfirmValidation
				}
				onCancel={() => {
					setValidateOpen(false);
					setValidateRow(null);
					setValidateCandidates([]);
					setValidateSelected(null);
				}}
			>
				{validateLoading ? (
					<Typography.Text>Cargando candidatos…</Typography.Text>
				) : validateCandidates.length === 0 ? (
					<>
						<Typography.Text>
							No hay coincidencias por CUIT para validar.
						</Typography.Text>
						<div style={{ marginTop: 12 }}>
							<Button type="primary" onClick={() => setCreateOpen(true)}>
								Crear nuevo PDV con estos datos
							</Button>
						</div>
					</>
				) : (
					<>
						<Typography.Paragraph>
							Elegí el <b>Punto de Venta</b> correcto para{" "}
							<b>{validateRow?.pdvName}</b> (CUIT {validateRow?.cuit || "-"})
						</Typography.Paragraph>
						<Radio.Group
							style={{ width: "100%" }}
							onChange={(e) => setValidateSelected(e.target.value)}
							value={validateSelected}
						>
							<List
								dataSource={validateCandidates}
								renderItem={(item) => (
									<List.Item>
										<Radio value={item.pointOfSaleId} style={{ width: "100%" }}>
											<div>
												<Typography.Text strong>{item.name}</Typography.Text>
												<div style={{ fontSize: 12, color: "#888" }}>
													CUIT: {item.cuit} • {item.address || "-"}
												</div>
											</div>
										</Radio>
									</List.Item>
								)}
							/>
						</Radio.Group>
					</>
				)}
			</Modal>

			{/* MODAL */}
			<Modal
				open={searchModalShow}
				onOk={handleModalOk}
				onCancel={handleModalCancel}
				width={900}
				centered={true}
				footer={null}
				destroyOnClose={true}
			>
				<ModalContainer>
					<PrePosTable
						data={data}
						columns={prePosColumns}
						loading={loading}
						pagination={{
							current: modalPage,
							pageSize: CONSTANTS.PAGE_BIG_SIZE,
							total: modalTotalRecords,
							showSizeChanger: false,
							onChange: (page) =>
								fetch_predefined_pos(searchPrePos || "", page),
						}}
						scrollData={{ y: 350 }}
					/>
				</ModalContainer>
			</Modal>

			<CreatePosModal
				open={createOpen}
				onCancel={() => setCreateOpen(false)}
				onSuccess={async () => {
					message.success("PDV creado y ruta validada.");
					setCreateOpen(false);
					setValidateOpen(false);
					setValidateRow(null);
					setValidateCandidates([]);
					setValidateSelected(null);
					await fetchAgentRoutePage({ search: searchTerm, page: 1 });
				}}
				agentRouteId={validateRow?.id}
				defaultCuit={validateRow?.cuit || ""}
				defaultName={validateRow?.pdvName || validateRow?.name || ""}
			/>

			<PosUsersModal
				open={posUsersOpen}
				onCancel={() => {
					setPosUsersOpen(false);
					setPosForUsers(null);
				}}
				pointOfSaleId={posForUsers}
				onSaved={async () => {
					message.success("Usuario actualizado.");
					setPosUsersOpen(false);
					setPosForUsers(null);
					fetchAgentRoutePage({ search: searchTerm, page: 1 });
				}}
				clientId={clientId}
				isSystemAdmin={isSystemAdmin}
				onValidateWhatsappSingle={handleValidateWhatsappSingle}
			/>

			<Modal
				title={
					<TitleContainer>
						<Typo
							type="primary"
							level={6}
							style={{ cursor: "pointer", userSelect: "none" }}
						>
							Importar datos <InfoCircleFilled />
						</Typo>
						<Typo level={7}>Información de archivo de subida</Typo>
						<Typo level={7}>Extensiones admitidas: .xlsx, .xls, .csv</Typo>
					</TitleContainer>
				}
				open={showUploadFileModal}
				onOk={handleUploadModalOk}
				onCancel={handleUploadModalCancel}
				centered={false}
				footer={null}
				destroyOnClose={true}
			>
				{/* {uploadType === CONSTANTS.ROUTE_VALIDATION && (
					<div
						style={{
							marginBottom: 12,
							display: "flex",
							flexDirection: "column",
						}}
					>
						<AntdCheckbox
							checked={forceOverwriteLockedWhatsapp}
							onChange={(e) =>
								setForceOverwriteLockedWhatsapp(e.target.checked)
							}
							disabled={loading}
						>
							Forzar overwrite de WhatsApp LOCKED
						</AntdCheckbox>
						<Typo type="danger" level={6}>
							Si está activo, al coincidir CUIT se pisa el WhatsApp aunque esté
							locked.
						</Typo>
					</div>
				)} */}
				<UploadFile
					multiple={false}
					showUploadList={false}
					beforeUpload={() => false}
					action={null}
					onChange={
						uploadType === CONSTANTS.ROUTE_ASSING
							? handleUpload
							: handleUploadToValidate
					}
					disabled={loading}
				>
					{loading ? (
						<Spin size="default" />
					) : (
						<Section>
							<Image src={CONSTANTS.URL_SHEET_ICON} width="80px" />
							<Typo level={7}>
								Haga click para elegir el archivo desde el explorador
							</Typo>
							<Typo level={7}>
								También puede arrastrarlo y soltarlo en este espacio
							</Typo>
						</Section>
					)}
				</UploadFile>
			</Modal>

			<Modal
				open={validateBulkModalOpen}
				onCancel={() => {
					setValidateBulkModalOpen(false);
					setValidateBulkResult(null);
				}}
				footer={[
					<Button
						key="download"
						onClick={() => {
							if (!validateBulkResult) return;
							const r = validateBulkResult;

							const text =
								`VALIDACIÓN MASIVA\n\n` +
								`Procesadas: ${r.processed}\n` +
								`Validadas: ${r.validated}\n` +
								`Clientes creados: ${r.createdClients}\n` +
								`PDV creados: ${r.createdPos}\n` +
								`Rutas creadas: ${r.createdRoutes}\n` +
								`Duplicados: ${r.duplicates}\n` +
								`Saltadas: ${r.skipped}\n` +
								`Errores: ${r.errors}\n\n` +
								`--- DUPLICATE CUITS ---\n` +
								(r.duplicateCuits?.join("\n") || "-") +
								`\n\n--- ERROR MESSAGES ---\n` +
								(r.errorMessages?.join("\n") || "-");

							downloadText(
								`validacion_masiva_${moment().format("YYYYMMDD_HHmm")}.txt`,
								text,
							);
						}}
					>
						Descargar txt detalle
					</Button>,
					<Button
						key="ok"
						type="primary"
						onClick={() => {
							setValidateBulkModalOpen(false);
							setValidateBulkResult(null);
						}}
					>
						Cerrar
					</Button>,
				]}
				title="Resultado de validación masiva"
				width={900}
			>
				{!validateBulkResult ? (
					<Spin />
				) : (
					<>
						<Row gutter={12} style={{ marginBottom: 12 }}>
							<Col span={6}>
								<Card size="small">
									<Typography.Text type="secondary">Procesadas</Typography.Text>
									<div style={{ fontSize: 22, fontWeight: 700 }}>
										{validateBulkResult.processed ?? 0}
									</div>
								</Card>
							</Col>
							<Col span={6}>
								<Card size="small">
									<Typography.Text type="secondary">Validadas</Typography.Text>
									<div style={{ fontSize: 22, fontWeight: 700 }}>
										{validateBulkResult.validated ?? 0}
									</div>
								</Card>
							</Col>
							<Col span={6}>
								<Card size="small">
									<Typography.Text type="secondary">Duplicados</Typography.Text>
									<div style={{ fontSize: 22, fontWeight: 700 }}>
										{validateBulkResult.duplicates ?? 0}
									</div>
								</Card>
							</Col>
							<Col span={6}>
								<Card size="small">
									<Typography.Text type="secondary">Errores</Typography.Text>
									<div style={{ fontSize: 22, fontWeight: 700 }}>
										{validateBulkResult.errors ?? 0}
									</div>
								</Card>
							</Col>
						</Row>

						<Space wrap style={{ marginBottom: 12 }}>
							<Tag color="blue">
								Clientes creados: {validateBulkResult.createdClients ?? 0}
							</Tag>
							<Tag color="blue">
								PDV creados: {validateBulkResult.createdPos ?? 0}
							</Tag>
							<Tag color="blue">
								Rutas creadas: {validateBulkResult.createdRoutes ?? 0}
							</Tag>
							<Tag color="default">
								Ignoradas: {validateBulkResult.skipped ?? 0}
							</Tag>
						</Space>

						<Typography.Paragraph type="secondary" style={{ marginBottom: 12 }}>
							Los errores suelen ser “Punto general inexistente” o referencias
							nulas. Los duplicados son CUITs con múltiples coincidencias.
						</Typography.Paragraph>

						<Tabs
							defaultActiveKey={
								(validateBulkResult.errors ?? 0) > 0 ? "errors" : "dups"
							}
							items={[
								{
									key: "errors",
									label: `Errores (${
										validateBulkResult.errorMessages?.length ?? 0
									})`,
									children: (
										<List
											size="small"
											bordered
											dataSource={validateBulkResult.errorMessages || []}
											style={{ maxHeight: 360, overflow: "auto" }}
											renderItem={(item) => (
												<List.Item>
													<Typography.Text>{item}</Typography.Text>
												</List.Item>
											)}
										/>
									),
								},
								{
									key: "dups",
									label: `CUIT duplicados (${
										validateBulkResult.duplicateCuits?.length ?? 0
									})`,
									children: (
										<List
											size="small"
											bordered
											dataSource={validateBulkResult.duplicateCuits || []}
											style={{ maxHeight: 360, overflow: "auto" }}
											renderItem={(cuit) => (
												<List.Item>
													<Space>
														<Tag color="warning">{cuit}</Tag>
														<Typography.Text type="secondary">
															Más de una coincidencia por CUIT
														</Typography.Text>
													</Space>
												</List.Item>
											)}
										/>
									),
								},
							]}
						/>
					</>
				)}
			</Modal>
		</Page>
	);
}
